import { Injectable } from '@angular/core';
import { ApiClient } from '../../shared';
import { GenericAccount } from '../../models/GenericAccount';
import { GenericTaxRate } from '../../models/generic-tax-rate';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

interface BrcTaxRate {
  id: number;
  description: string;
  rate: number;
}

@Injectable()
export class BrcSettingsService {
  constructor(private http: ApiClient) {}

  getBRCStatus() {
    return this.http.get<{ connected: boolean }>(
      'settings/big-red-cloud/status'
    );
  }

  getAccounts() {
    return this.http.get<GenericAccount[]>('settings/big-red-cloud/accounts');
  }

  getConfiguredAccounts() {
    return this.http.get<{ [key: string]: string }>(
      'settings/big-red-cloud/configured-accounts'
    );
  }

  saveAccountMappings(mappings) {
    return this.http.post('settings/big-red-cloud/configured-accounts', {
      mappings
    });
  }

  getTaxRates(): Observable<GenericTaxRate[]> {
    return this.http.get<BrcTaxRate[]>('settings/big-red-cloud/tax-rates').pipe(
      map((rates) =>
        rates.map<GenericTaxRate>((rate) => ({
          tax_id: rate.id,
          tax_name: rate.description ? rate.description : 'No description',
          tax_percentage: rate.rate
        }))
      ),
      tap((rates) => console.log({ rates }))
    );
  }

  saveTaxMappings(mappings) {
    return this.http.post('settings/big-red-cloud/tax-rates', { mappings });
  }

  importCustomers() {
    return this.http.get<{ info: string }>(
      'settings/big-red-cloud/import-customers'
    );
  }
}
